<!--
2021-07-06 CHP 增加withdraw实名认证相关逻辑
2022-01-26 CHP 双账号
2022-02-17 CHP 支持多国家、多货币(充值、提款、认证)
-->
<template>
  <div>
    <div class="accountPage" v-if="mounted" id="accountPage">
      <TopBack v-if="0" :title="topTitle"/>
      <div class="tabList">
        <div
          class="tab"
          :class="{'tabSelected': $route.name.startsWith(item.key)}"
          v-for="(item, index) in tabList"
          :key="index"
          @click="selectTab(item.key)">
          {{ item.label }}
        </div>
      </div>
      <div class="waringBox">
        <div
          v-if="warningShow&&($route.name === 'Deposit'&&gatewayList&&gatewayList.length>0)"
          class="warning">
          <!--        {{ WarningEN }}-->
          {{ $store.state.locale === 'EN' ? WarningEN : WarningIN }}
        </div>
      </div>
      <div class="waringBox">
        <div
          v-if="WithdrawwarningShow&&$route.name === 'Withdraw'"
          class="warning">
          {{ $store.state.locale === 'EN' ? WithdrawableWarningEN : WithdrawableWarningIN }}
        </div>
      </div>
      <div class="tabContainer">
        <div class="account" v-if="$route.name === 'Account'">
          <div class="row">
            <div class="caption">
              <span>{{ $t('lang.account.totalBalance') }}</span>
            </div>
            <div class="inputRow">
              <div style="color: #FFFFFF; border: none; font-size: 30px; font-weight: bold">
                {{
                  fetchCurrency[userInfo.CurrencyName]
                }}{{
                  separateThousand(this.accountInfo.Cash + this.accountInfo.Gift + this.accountInfo.WithdrawableCash)
                }}
              </div>
            </div>
            <div class="secondaryRow">
            <span class="title">
              {{ $t('lang.account.withdrawableBalance') }}:
            </span>
              <span class="amount">
              {{ fetchCurrency[userInfo.CurrencyName] }}{{ separateThousand(this.accountInfo.WithdrawableCash) }}
            </span>
            </div>
          </div>
          <!--        <div class="row">
                    <div class="caption">
                      <span>{{$t('lang.account.safeWallet')}}</span>
                    </div>
                    <div class="safe-wallet-row">
                      <div class="input">
                        <div>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.Wallet)}}</div>
                      </div>
                      <div class="btn" @click="() => toTransfer('safe')">
                        <div class="btn-inner">
                          <img :src="transfer" class="icon">
                          <span class="text">{{$t('lang.account.transfer')}}</span>
                        </div>
                      </div>
                    </div>
                  </div>-->
          <div class="row">
            <div class="caption">
              <span>{{ $t('lang.account.cash') }}</span>
            </div>
            <div class="inputRow">
              <div>
                {{
                  fetchCurrency[userInfo.CurrencyName]
                }}{{ separateThousand(this.accountInfo.Cash + this.accountInfo.Gift) }}
              </div>
            </div>
            <div class="btnRow">
              <div class="depositBtn" @click="selectTab('Deposit')">{{ $t('lang.account.deposit') }}</div>
              <div class="withdrawBtn" @click="selectTab('Withdraw')">{{ $t('lang.account.withdraw') }}</div>
            </div>
          </div>
          <div class="row">
          </div>
        </div>
        <div class="deposit" v-if="$route.name === 'Deposit'&&gatewayList&&gatewayList.length>0">
          <UpiInfoPop v-if="UpiInfoPopShow" @close="UpiInfoPopShow=false" @commitUPIInfo="commitUPIInfo"></UpiInfoPop>
          <BankCardInfoPop v-if="BankCardInfoPopShow"></BankCardInfoPop>
          <BankTransferInfoPop v-if="BankTransferInfoPopShow"
                               @close="BankTransferInfoPopShow=false"></BankTransferInfoPop>
          <div class="row">
            <div class="nav">
              <!--              <div class="new" v-if="gatewayTypes&&gatewayTypes.length>1"><img :src="newIcon"/></div>-->
              <div class="nav-item" v-for="(item, index) in gatewayTypes" :key="index"
                   :class="{'active':depositNav === item.GatewayType}"
                   @click="selectDepositTab(item.GatewayType)">
                <span>{{ item.GatewayType }}</span>
                <div class="activeEvent" v-if="activeEventOfNav(item.GatewayType)">{{
                    $t('lang.depositBonus.ActiveEvent')
                  }}
                </div>
              </div>
            </div>
            <div class="gateways-by-type" v-for="(tpeItem, index) in gatewayTypes" :key="index"
                 :class="{'gateways-by-type-active':depositNav === tpeItem.GatewayType}">
              <div class="gatewayRow" style="margin-top: 10px">
                <div class="gatewayItem" style="width: calc((100vw - 32px)/2)"
                     v-for="(item, index) in gatewayListByType" :key="index">
                  <!--Temp临时处理不显示mcpay的通道             v-if="item.Name.toLowerCase()!=='mcpay'"-->
                  <div class="gatewayRadio" @click="fetchTransaction(item)">
                    <input :id="'rd' + index" type="radio" style="height: 4vw;width: 4vw" :value="item"
                           v-model="selectedGateway"/>
                    <div class="inlineDiv">
                      <!--                      <div class="fire" v-if="index===0&&depositNav.toLowerCase()==='upi'"><img :src="fire"/></div>-->
                      <label :for="'rd' + index" class="gatewayTxt">{{
                          item.AnotherName ? item.AnotherName : $t('lang.account.gateway') + '#' + item.No
                        }}</label>
                      <!--                      <div class="gatewayDiscount" v-if="item.DiscountRange !== '' && item.DiscountRange !== null">-->
                      <!--                        +{{ item.DiscountRange }}-->
                      <!--                      </div>-->
                      <div class="activeEvent"
                           v-if="DepositGatewayActivity&&DepositGatewayActivity.length>0&&DepositGatewayActivity.includes(item.Name)"
                           style="right: -8vw">{{ $t('lang.depositBonus.ActiveEvent') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="how2UseUpi" v-if="depositNav.toLowerCase()==='bank card'">
                <img :src="question" @click="how2UseUpi">
                <div @click="how2UseUpi">{{ $t('lang.upi.how') }}</div>
              </div>
              <div class="howtoDeposit" v-if="false">
                Tips: How to deposit?&nbsp;&nbsp;<a @click="showDepositStep = true">click</a></div>
              <div class="depositWord">
                <span>{{ $t('lang.account.amount') }}</span>
                <div class="upiTeachingIcon" v-if="$route.name === 'Deposit'&&UpiUser&&UpiUser.ActivitySwitch===true"
                     @click="UpiIconClick">
                  <div class="img">
                    <div class="redPoint" v-if="UpiUser.RedDot===true"/>
                    <img :src="upiTeachingIcon" alt=""/>
                  </div>
                </div>
              </div>
              <div class="inputRow" v-for="(item, index) in selectedGateway.DepositRange" :key="index"
                   v-if="gatewayListByType.length > 0 && selectedGateway.Name != 'CoinsPay'">
                <div
                  v-for="(amount, indx) in item"
                  :key="index + '_' + indx"
                  :class="{'selected': amount === depositAmount}"
                  v-if="fetchRange(amount, 'deposit')"
                  @click="fetchAmount(amount, 'deposit', index, indx)"
                >
                  <div
                    :class="changeDepositRangeBg(index)"
                    v-if="selectedGateway.DepositDiscountRange && selectedGateway.DepositDiscountRange[index] && selectedGateway.DepositDiscountRange[index][indx]"
                  >
                    +{{ selectedGateway.DepositDiscountRange[index][indx] }}
                  </div>
                  <div v-else class="discountRange" style="background: none;"></div>
                  <span>
                  {{ separateThousandInteger(amount) }}
                </span>
                </div>
              </div>
              <div class="inputRow" v-for="(item, index) in coinsPayList" :key="index"
                   v-if="selectedGateway.Name == 'CoinsPay'">
                <div>
                  <div class="coin-name">{{ item.Coin }}</div>
                  <div class="coin-copy" @click.stop="coinCopyAddress(item.Address)">Copy</div>
                  <div class="coin-address">{{ item.Address }}</div>
                </div>
              </div>
            </div>
            <div class="compute-deposit-discount" v-if="gatewayListByType.length > 0">
              <table cellspacing="1px" class="depositTotalTable">
                <tr>
                  <td>{{ $t('lang.account.cash') }}</td>
                  <td></td>
                  <td>{{ $t('lang.account.bonus') }}</td>
                  <td></td>
                </tr>
                <tr>
                  <td>{{ depositCashBonus.amount }}</td>
                  <td>+</td>
                  <td>{{ depositCashBonus.cash }}</td>
                  <td>= {{ depositCashBonus.total }}</td>
                </tr>
              </table>
            </div>
            <div class="discountTypeChoose">
              <div class="bonus">{{ $t('lang.account.bonus') }}</div>
              <div class="choose" v-show="!showUpiHelpPop">
                <div class="discountName">{{ discountName }}</div>
                <div class="chooseDrop"><img :src="chooseDrop" alt="chooseDrop"/></div>
                <div class="mask" @click="showTypeDrop"/>
                <div class="typeDropList" v-if="typeDropShow">
                  <div class="item"
                       :class="judgeActive(item)?'active':''"
                       v-for="(item,index) in discounts" :key="index" @click="chooseDiscountType(item)">{{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="deposit-step" v-if="showDepositStep">
                <div class="cancel-btn" v-show="tipsDelayAwhile" @click="closeDepositStep">
                  <img style="width: 40px;"
                       src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguOTk2IDQuNzEyODlDMTEuMTEzNCA0LjcxMjg5IDQuNzEyODkgMTEuMTEzMyA0LjcxMjg5IDE4Ljk5NjZDNC43MTI4OSAyNi44Nzk5IDExLjExMzQgMzMuMjgwMyAxOC45OTYgMzMuMjgwM0MyNi44ODEgMzMuMjgwMyAzMy4yNzkzIDI2Ljg3OTkgMzMuMjc5MyAxOC45OTY2QzMzLjI3OTMgMTEuMTEzMyAyNi44ODEgNC43MTI4OSAxOC45OTYgNC43MTI4OVpNMTguOTk2IDYuNjEyODlDMjUuODMxMyA2LjYxMjg5IDMxLjM3OTMgMTIuMTYxOCAzMS4zNzkzIDE4Ljk5NjZDMzEuMzc5MyAyNS44MzEzIDI1LjgzMTMgMzEuMzgwMyAxOC45OTYgMzEuMzgwM0MxMi4xNjA4IDMxLjM4MDMgNi42MTI4OSAyNS44MzEzIDYuNjEyODkgMTguOTk2NkM2LjYxMjg5IDEyLjE2MTggMTIuMTYwOCA2LjYxMjg5IDE4Ljk5NiA2LjYxMjg5WiIgZmlsbD0iI0Y2RDlBQSIgZmlsbC1vcGFjaXR5PSIwLjYiLz4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjUuNDUzMiAxMS4yMTA4TDExLjIyNDQgMjUuNDM5N0MxMC44NTM2IDI1LjgxMDUgMTAuODUzMiAyNi40MTIgMTEuMjI0NCAyNi43ODMyQzExLjU5NTUgMjcuMTU0MyAxMi4xOTcxIDI3LjE1NCAxMi41Njc5IDI2Ljc4MzJMMjYuNzk2OCAxMi41NTQzQzI3LjE2NzQgMTIuMTgzNyAyNy4xNjc5IDExLjU4MiAyNi43OTY4IDExLjIxMDhDMjYuNDI1NiAxMC44Mzk3IDI1LjgyMzkgMTAuODQwMiAyNS40NTMyIDExLjIxMDhaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNi43ODkyIDI1LjQzNDdMMTIuNTYwMyAxMS4yMDU4QzEyLjE4OTUgMTAuODM1IDExLjU4OCAxMC44MzQ3IDExLjIxNjggMTEuMjA1OEMxMC44NDU3IDExLjU3NyAxMC44NDYgMTIuMTc4NSAxMS4yMTY4IDEyLjU0OTNMMjUuNDQ1NyAyNi43NzgyQzI1LjgxNjMgMjcuMTQ4OCAyNi40MTggMjcuMTQ5MyAyNi43ODkyIDI2Ljc3ODJDMjcuMTYwMyAyNi40MDcxIDI3LjE1OTggMjUuODA1MyAyNi43ODkyIDI1LjQzNDdaIiBmaWxsPSIjRjZEOUFBIiBmaWxsLW9wYWNpdHk9IjAuNiIvPg0KPC9zdmc+DQo=">
                </div>
                <div class="deposit-step-img">
                  <img :src="DepositStepImg"/>
                </div>
              </div>
            </div>
          </div>

          <div class="submit" @click="handleDeposit" v-if="selectedGateway.Name != 'CoinsPay'">
            {{ $t('lang.account.submit') }}
          </div>
          <div class="carlousel">
            <DWCarousel>
            </DWCarousel>
          </div>
        </div>
        <div class="withdraw" v-if="$route.name === 'Withdraw'">
          <div class="balanceBox">
            <div class="historyPropBtn" @click="goHistory">
              {{ $t('lang.WithdrawalSuccessful.history') }}>
            </div>
            <div class="balance-caption">
              {{ $t('lang.account.withdrawableBalance') }}
            </div>
            <div class="cashCount">
              <div style="flex: 1">
              <span>{{ fetchCurrency[userInfo.CurrencyName] }}{{
                  separateThousand(this.accountInfo.WithdrawableCash)
                }}</span>
              </div>
            </div>
            <div
              class="gift-prompt"
              v-if="this.accountInfo.Gift > 0"
              v-html="$t('lang.account.betThenWithdraw', {
            bet: `${fetchCurrency[userInfo.CurrencyName]}${separateThousand(this.accountInfo.BetingToConvertToWithdrawableCash + this.accountInfo.Cash)}`,
            withdraw: `${fetchCurrency[userInfo.CurrencyName]}${separateThousand(this.accountInfo.Gift + this.accountInfo.Cash)}`
          })"
            >
            </div>
          </div>

          <div class="row" style="margin-top: 20px">
            <!--            <div class="operateRow">-->
            <!--              <div class="label">{{ $t('lang.account.bankAccount') }}</div>-->
            <!--              <img :src="ok"-->
            <!--                   v-if="$store.state.verifyInfo && activeBankAccount&&activeBankAccount.BankCardVerifyStatus == 20">-->
            <!--              <img :src="warn"-->
            <!--                   v-if="$store.state.verifyInfo && activeBankAccount&&activeBankAccount.BankCardVerifyStatus == -10">-->
            <!--              <div class="btn" @click="withdrawSetup='account'">-->
            <!--              <span-->
            <!--                v-if="!$store.state.verifyInfo || !activeBankAccount||(activeBankAccount&&activeBankAccount.BankCardVerifyStatus <= 0)">{{-->
            <!--                  $t('lang.account.set')-->
            <!--                }}</span>-->
            <!--                <span-->
            <!--                  v-if="$store.state.verifyInfo && (activeBankAccount&&activeBankAccount.BankCardVerifyStatus > 0)">{{-->
            <!--                    $t('lang.menu.Account')-->
            <!--                  }} {{-->
            <!--                    (activeBankAccount.Index + 1) * 1-->
            <!--                  }}</span>-->
            <!--              </div>-->
            <!--              <div class="tips-warn"-->
            <!--                   v-if="(activeBankAccount&&activeBankAccount.BankCardVerifyStatus <= 0)&&activeBankAccount.BankMessage">-->
            <!--                {{ activeBankAccount.BankMessage }}-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
          <div class="row" style="text-align: right"
               v-if="$store.state.verifyInfo && activeBankAccount&&activeBankAccount.BankCardVerifyStatus < 20 && $store.state.verifyInfo.BankMessage">
            <span class="audit-message">{{ $store.state.verifyInfo.BankMessage }}</span>
          </div>
          <div class="caption">
            {{ $t('lang.account.amount') }}
          </div>
          <div class="tips">
            {{ $t('lang.account.selectAmount') }}
          </div>
          <div class="row">
            <div class="inputRow" v-for="(item, index) in withdrawAmountList" :key="index">
              <div
                v-for="amount in item"
                :key="amount"
                :class="{'selected': amount === withdrawAmount}"
                @click="fetchAmount(amount, 'withdraw')"
              >
                {{ separateThousandInteger(amount) }}
              </div>
            </div>
          </div>
          <!-- 2022-1-12 LBL 修改warning为文字链接，点击弹出withdrawal rule 弹窗 -->
          <div class="tips warnings pointer" @click="showWithdrawalRules">
            {{ $t('lang.account.withdrawalRules') }}
          </div>
          <div class="submit" @click="isMondayOrWeekend()">{{ $t('lang.account.submit') }}</div>
          <div class="withdrawSetupBoxMarsk" v-if="withdrawSetup">
            <!--            <img src="../../assets/images/WithdrawalSuccessful/close.png" @click="withdrawSetup = ''" alt="" :class="getWindowHeight===1 ? 'close' : 'close2'">-->
            <div class="withdrawSetupBox">
              <Setup :withdrawAmount="withdrawAmount" :selectTab="selectTab" @doWithdraw="doWithdraw"
                     @close="withdrawSetup = ''" :withdrawFee="withdrawFee" @openDeatilShow="openDeatilShow"
                     :setupType="withdrawSetup"
                     :parentChoose="chooseCard" :handelBack="()=>{this.withdrawSetup=''}"/>
            </div>
          </div>
          <div class="withdrawBanner" v-if="0">
            <img src="" alt="NOT IMAGE! PLEASE UPLOAD IMAGE!">
          </div>
        </div>
      </div>
      <form ref="form" :action="GladPayUrl" method="post" v-show="0">
        <input type="hidden" v-for="(key, index) in Object.keys(formData)" :key="index" :name="key"
               :value="formData[key]">
      </form>
      <div class="pop-message-wrapper" v-show="showPopMessage">
        <ul class="pop-message-content">
          <p v-html="popMessage"></p>
          <div class="close-pop-message">
                          <span class="close-pop-btn" @click="showPopMessage=false"
                                v-show="popType !== 2">{{ $t('lang.common.cancel') }}</span>
            <span class="close-pop-btn" @click="closeDepositMsgPop">{{ $t('lang.common.ok') }}</span>
          </div>
        </ul>

      </div>
      <div class="maskBg" v-show="showPopMessage2">
        <div class="pop-message-wrapper2">
          <ul class="pop-message-content">
            <p v-html="popMessage2"></p>
            <div class="close-pop-message">
              <span class="close-pop-btn" @click="closeDepositMsgPop2">{{ $t('lang.common.ok') }}</span>
            </div>
          </ul>

        </div>
      </div>
      <UpiActivity
        v-show="UpiActivityShow"
        :goToUpiTeaching="UpiPopGoClick"
        :handleClose="closeUpiActivityShow"
      />
      <TeachingPop
        v-if="TeachingPopShow"
        :handleClose="closeTeaching"
        :finishUpiStudy="finishUpiStudy"
      />
      <UpiGiftReward
        v-if="showUpiGiftReward"
        :handleClose="closeUpiGiftReward"
        :btnText="this.$t('lang.upiTeaching.button' + this.teachingAlertMode)"
        :nextToDo="UpiGiftRewardToDo"
      >
        <div class="slots">
          <div class="title" v-if="teachingAlertMode!==3" v-for="(title,index) in $t('lang.upiTeaching.title')"
               :key="index">
            {{ title }}
          </div>
          <div class="reward" v-if="teachingAlertMode!==3">
            {{ $t('lang.account.currencyType') }}{{ separateThousand(UpiUser.Reward) }}
          </div>
          <div class="desc" v-if="teachingAlertMode===1"
               v-html="$t('lang.upiTeaching.desc').replace('{amount}',UpiUser.Target)"/>
          <div class="sentence" v-if="teachingAlertMode===3" v-html="$t('lang.upiTeaching.sentence')"/>
        </div>
      </UpiGiftReward>
      <VersionUpdatePop v-show="showUpgradePop"
                        promptType="2"
                        :handleClose="closeUpgrade"></VersionUpdatePop>
      <UpiHelpPop v-show="showUpiHelpPop"
                  :handleClose="closeUpiHelp"></UpiHelpPop>
      <ConfirmWin v-if="this.$store.state.confirmWinShow"
                  :hintText="withdrawConfirmText"
                  :okText="$t('lang.account.yesWithdraw')"
                  :cancelText="$t('lang.account.noWithdraw')"
                  :confirmToDo="confirmWithDraw"></ConfirmWin>
      <ConfirmAlert
        v-if="payRuAlertShow"
        :title="$t('lang.account.requirement')"
        :hintText="$t('lang.account.alertTips')"
        :okText="$t('lang.account.iSee')"
        :cancelText="$t('lang.account.noWithdraw')"
        :confirmToDo="closePayRu"
      />
      <WaitModal
        ref="waitModal"
        v-show="$store.state.waitShow"
        @closed="onModalClose"
        @navigate="proceedToNextRoute"
        :userInfo="userInfo"
      />
      <GatewayError ref="GatewayError"
                    v-show="gatewayErrorShow"
                    :handleClose="closeGatewayError"
                    :doNewOrder="doNewOrder"
                    :retryMsg="retryObject.RetryMsg"
                    :newOrderShow=false
      />
      <!--                    :newOrderShow="retryObject&&retryObject.Gateway"-->
      <Alert2
        ref="Alert2"
        v-if="showBindMobileAlert"
        :yesText="$t('lang.luckyWheel.executeBtn')"
        :closeText="$t('lang.luckyWheel.cancel')"
        :text="$t('lang.setting.bindFirst')"
        :closeClick="closeBindMobile"
        :yesClick="gotoEdit"
      />
      <!--      周一周末不提款提示框-->
      <div class="noWithdrawalsOnWeekendsMarsk" v-if="mondayOrWeekendPopShow">
        <div class="noWithdrawalsOnWeekendsPop">
          <div class="noWithdrawalsOnWeekendsPopTitle">{{ $t('lang.account.noWithdrawalsOnWeekendsPopTitle') }}</div>
          <div class="ConfirmWithdrawal" @click="handleWithdraw()">{{ $t('lang.account.ConfirmWithdrawal') }}</div>
          <div class="Cancel" @click="mondayOrWeekendPopShow = false">{{ $t('lang.account.Cancel') }}</div>
        </div>
      </div>

      <!-- payFuture 通道充值提示语-->
      <div class="payFutureMsg" v-if="payFutureMsgShow">
        <div class="msgCard">
          <div class="msg">{{ $t('lang.account.payFutureMsg1') }}</div>
          <div class="msg">{{ $t('lang.account.payFutureMsg2') }}</div>
          <div class="button" @click="closePayFutureMsg">{{ $t('lang.inviteFriends.close') }}</div>
        </div>
      </div>
    </div>
    <div class="deatilMask" v-if="deatilShow">
      <div class="deatilBox">
        <div class="title">{{ $t('lang.WithdrawalSuccessful.detail') }}</div>
        <div class="contentBox" v-html="formatterRuleContent(detailContent)">
        </div>
        <div class="cancel" @click="deatilShow = false">{{ $t('lang.common.cancel') }}</div>
      </div>
    </div>
    <div class="QRCodeMask" v-if="QRCodeShow">
      <div class="QRCodeBox">
        <div class="title">{{ $t('lang.common.ScanPay') }}</div>
        <div class="tipBox">{{ $t('lang.common.ScanPayTip') }}</div>
        <div class="QRCodeImgBox">
          <img :src="QRCode" alt="" class="QRCode">
        </div>
        <div class="PaymentOnceOnly">{{ $t('lang.common.PaymentOnceOnly') }}</div>
        <img @click="QRCodeShow = false" src="../../assets/images/account/close.png" alt="" class="close">
      </div>
    </div>
  </div>
</template>

<script>
import UpiGiftReward from '@/components/UpiGiftReward/index'
import TeachingPop from '@/components/UPITeaching/index'
import upiTeachingIcon from '@/assets/images/account/UPPayTeachingIcon.gif'
import UpiActivity from '@/components/UpiActivityPop/index'
import {Loadmore, Toast} from 'mint-ui'
import Setup from '@/components/WithdrawSetup/index'
import WithdrawalRule from '@/components/WithdrawalRules/index'
import WaitModal from '@/components/WaitModal/index'
import GatewayError from '@/components/GatewayError/index'
import {mapMutations} from 'vuex'
import {separateThousand, getUTCNow, separateThousandInteger, LogUtils, fetchBalance} from '@/utils'
import {fetchCurrency, InternationWithdrawAmountRange} from '@/constant'
import request from '@/service'
import fire from '@/assets/images/account/fire.svg'
import question from '@/assets/images/account/question.svg'
import newIcon from '@/assets/images/account/new.svg'
import showMore from '@/assets/images/common/showMore.gif'
import ok from '@/assets/images/common/ok.svg'
import warn from '@/assets/images/common/warn.svg'
import whatsapp from '@/assets/images/common/whatsapp.svg'
import copyLink from '@/assets/images/common/copylink.svg'
import UpiHelpPop from '@/components/UpiHelpPop/index'
import VersionUpdatePop from '@/components/VersionUpdatePop/index'
import transfer from '@/assets/images/account/transfer.png'
import transfer2 from '@/assets/images/account/transfer2.png'
import circule from '@/assets/images/account/circule.png'
import DWCarousel from '@/components/GatewayWithdrawCarousel/index'
import DepositStepImg from '@/assets/images/account/deposit_steps.jpg'
import TopBack from '@/components/TopBack/index'
import gatewayHot from '@/assets/images/gateway/gatewayHot.svg'
import ConfirmWin from '@/components/ConfirmWin/confirmWithTwoButton'
import ConfirmAlert from '@/components/ConfirmWin/Alert'
import Alert2 from '@/components/ConfirmWin/Alert2'
import chooseDrop from '@/assets/images/account/chooseDrop.svg'
import UpiInfoPop from '@/components/UpiInfoPop'
import BankCardInfoPop from '@/components/BankCardInfoPop'
import BankTransferInfoPop from '@/components/BankTransferInfoPop'

export default {
  name: 'Account',
  data () {
    return {
      QRCodeShow: false,
      QRCode: null,
      mondayOrWeekendPopShow: false,
      payFutureMsgShow: false,
      UpiInfoPopShow: false,
      BankTransferInfoPopShow: false,
      BankCardInfoPopShow: false,
      deatilShow: false,
      detailContent: '',
      ConfigList: [],
      lang: localStorage.getItem('locale'),
      gatewayErrorShow: false,
      retryObject: {},
      leaveToRoute: '',
      waitPopShow: false,
      DepositGatewayActivity: [],
      discountTimeInterval: null,
      discountName: '',
      discounts: [],
      activity: {},
      IsLastUsed: -1,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      showTab: 'Account',
      firstDepositGiftRatio: 0,
      firstDepositMaxGift: 0,
      discountType: 'normal_deposit',
      topTitle: this.$t('lang.menu.' + this.$route.name),
      tabList: [
        {
          label: this.$t('lang.account.wallet'),
          key: 'Account'
        },
        {
          label: this.$t('lang.account.deposit'),
          key: 'Deposit'
        },
        {
          label: this.$t('lang.account.withdraw'),
          key: 'Withdraw'
        }
      ],
      accountInfo: {},
      bonusClaim: '',
      withdrawAmountList: [
        [
          500, 1000, 2000, 5000
        ],
        [
          10000, 30000, 50000
        ]
      ],
      depositAmount: 0,
      VpaAddress: undefined,
      withdrawAmount: 0,
      depositRange: {
        Min: 0,
        Max: 0
      },
      withdrawRange: {
        Min: 0,
        Max: 0
      },
      bonusCheck: true, // 2022-02-19 CHP 默认改为选中，加强Bonus的推广效果
      agreeCheck: true,
      mounted: false,
      showUpiHelpPop: false,
      fetchCurrency,
      InternationWithdrawAmountRange,
      getUTCNow,
      GladPayUrl: '',
      formData: {},
      fetchBalance,
      separateThousand,
      separateThousandInteger,
      newIcon,
      fire,
      question,
      showMore,
      firstRewardLoad: true,
      firstReferralLoad: true,
      referralList: [],
      coinsPayList: [],
      withdrawSetup: '',
      claimBonus: false,
      ok: ok,
      warn: warn,
      whatsapp: whatsapp,
      copyLink: copyLink,
      minDeposit: null,
      minDepositCids: null,
      gatewayList: [],
      gatewayTypes: [], // 支付网关类型 by HHY 20220609
      gatewayListByType: [],
      selectedGateway: '', // 选择的支付网关
      showPopMessage: false,
      showPopMessage2: false,
      popMessage: '',
      popMessage2: '',
      feeFreeStatus: 0,
      withdrawFee: 0,
      showUpgradePop: false,
      popType: 0, // 0: 支付请求之前 1: 支付请求之后,
      showWithdrawalRule: false,
      transfer,
      transfer2,
      circule,
      chooseDrop,
      typeDropShow: false,
      freshNav: true,
      depositNav: '', // 选择Gatewaytype的tab时用
      depositCashBonus: { // 当充值点击充值额度时，计算充值返利和奖金 By HHY 2022-08-16
        amount: 0,
        cash: 0,
        // bonus: 0,
        total: 0
      },
      showDepositStep: false, // 是否显示充值步骤引导图
      DepositStepImg,
      cashUpPerc: 0, // 充值优惠比例
      gatewayHot,
      tipsDelayAwhile: false, // 充值提示弹图
      isFromPromotionUpiGuide: false,
      waitingGatewaysInterval: null,
      isFirstDeposit: false, // 首充50%现金奖励用 2022-10-23 HHY
      withdrawConfirmText: '',
      activeCardId: -1,
      activeBankAccount: null,
      WarningEN: '',
      WarningIN: '',
      WithdrawableWarningEN: '',
      WithdrawableWarningIN: '',
      warningShow: false,
      WithdrawwarningShow: false,
      payRuAlertShow: false,
      upiTeachingIcon,
      TeachingPopShow: false,
      teachingAlertMode: 1, // 1 已学习未达到充值目标 2 待领取 3已领取
      UpiUser: {
        ActivitySwitch: false,
        ForcePopUp: false,
        PopUpEnd: true,
        RewardEnd: false,
        StudyEnd: false,
        RedDot: false,
        Reward: 0,
        Target: 0
      },
      UpiActivityShow: false,
      showUpiGiftReward: false,
      showBindMobileAlert: false
    }
  },
  components: {
    Loadmore,
    DWCarousel,
    Setup,
    UpiGiftReward,
    TeachingPop,
    UpiActivity,
    UpiHelpPop,
    VersionUpdatePop,
    WithdrawalRule,
    WaitModal,
    GatewayError,
    TopBack,
    ConfirmWin,
    ConfirmAlert,
    Alert2,
    UpiInfoPop,
    BankCardInfoPop,
    BankTransferInfoPop
  },
  computed: {
    getWindowHeight () {
      let height = window.innerHeight
      console.log(height)
      if (height > 740) {
        return 2
      } else {
        return 1
      }
    },
    tabCase () {
      return (item) => {
        return this.$route.name.startsWith(item.key) ? item.label.toUpperCase() : item.label
      }
    },
    fetchRange () {
      return (amount, type) => {
        switch (type) {
          case 'deposit':
            // START: 2021-08-23 C007 根据当前选择的网关展示对应的可充值列表
            if (this.selectedGateway) {
              // 2021-11-25 CHP 24小时充值送只能进行 100、500、1000 三种数额
              return amount >= this.selectedGateway.DepositMinAmount && amount <= this.selectedGateway.DepositMaxAmount
            } else {
              return true
            }
          // END: 2021-08-23 C007
          case 'withdraw':
            return amount >= this.withdrawRange.Min && amount <= this.withdrawRange.Max
        }
      }
    }
  },
  watch: {
    selectedGateway (val) {
    },
    '$store.state.locale': function (val) {
      this.lang = val
      this.topTitle = this.$t('lang.menu.' + this.$route.name)
      this.tabList = [
        {
          label: this.$t('lang.menu.Account'),
          key: 'Account'
        },
        {
          label: this.$t('lang.account.deposit'),
          key: 'Deposit'
        },
        {
          label: this.$t('lang.account.withdraw'),
          key: 'Withdraw'
        }
      ]
      this.discounts.forEach((discount) => {
        if (discount.type === 'wheel_deposit' || discount.type === 'deposit630_discount' || discount.type === 'inner_discount' || discount.type === '7day_gift_version_c') {
          discount.onlyName = this.$t('lang.account.' + discount.type)
          const timeShow = this.getRemainingTime(discount.date)
          discount.name = discount.onlyName + ' ' + discount.rate + '% (' + timeShow + ')'
        } else {
          discount.name = this.$t('lang.account.' + discount.type)
        }
      })
      if (this.discountName) {
        if (this.discountType === 'wheel_deposit' || this.discountType === 'deposit630_discount' || this.discountType === 'inner_discount' || this.discountType === '7day_gift_version_c') {
          this.discountName = this.discounts.filter((e) => {
            return e.guid && e.guid === this.discountGuid
          })[0].name
        } else {
          this.discountName = this.$t('lang.account.' + this.discountType)
        }
      }
    },
    'withdrawSetup': function (n, o) {
      let accountPage = document.getElementById('accountPage')
      if (n) {
        accountPage.scrollTop = 0
      }
    },
    '$route' (to, from) {
      const key = to.name
      const tab = this.tabList.find(item => item.key === key)
      if (tab.key === 'Account') {
        this.topTitle = this.$t('lang.menu.Account')
      } else {
        this.topTitle = tab.label
      }
      if (!localStorage.getItem('userInfo')) {
        this.$router.push('/Login')
        // this.$store.commit('setLoginPopShow', true)
      } else {
        if (to.name === 'Deposit') {
          this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
          this.getDepositActivity()
          if (from.name !== 'Deposit') {
            this.getUpiUserData()
          }
        } else if (to.name === 'Withdraw') {
          this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
          this.fetchVerifyInfo()
        }
      }
      if (to.name === from.name) { // 临时处理跳转入upi tab返回不成功
        this.$router.push('/Home')
      }
    }
  },
  created () {
    if (!localStorage.getItem('userInfo')) {
      this.$router.push('/Login')
      // this.$store.commit('setLoginPopShow', true)
    } else {
      if (this.$route.name === 'Deposit') {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.getDepositActivity()
      } else if (this.$route.name === 'Withdraw') {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.fetchVerifyInfo()
      }
    }
  },
  mounted () {
    // this.$store.state.confirmWinShow = true // 弹出confirm窗
    if (!localStorage.getItem('userInfo')) {
      return
    }
    // this.selectDepositTab('UPI')//E-Wallet
    this.getWarning()
    if (!localStorage.getItem('waitShowDate')) {
      this.waitPopShow = true
    } else {
      this.waitPopShow = !LogUtils.isSameDay(Date.now(), localStorage.getItem('waitShowDate') * 1)
    }
    this.showTipsContentByDelay() // 充值tips关闭按钮延迟显示
    localStorage.setItem('currencyIcon', fetchCurrency[this.userInfo.CurrencyName])

    this.fetchAccount()

    if (this.$route.name === 'Withdraw') {
      // 2022-02-17 CHP 根据国家版本确定提款范围
    } else if (this.$route.name === 'Deposit') {
      // 获取Upi教学活动配置
      this.getUpiUserData()
    }
    this.mounted = true
    if (!this.discountTimeInterval) {
      this.discountTimeInterval = setInterval(() => {
        this.updateDiscountDate()
      }, 60000)
    }
  },
  updated () {
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setUserVerifyInfo: 'setUserVerifyInfo',
      setUserBankList: 'setUserBankList'
    }),
    formatterRuleContent (content) {
      return content.replace(/\\n|\r?\n/g, '</p><p>')
    },
    commitUPIInfo (v) {
      this.VpaAddress = v
      this.doDeposit()
    },
    goHistory () {
      this.$router.push({
        path: '/History',
        query: {
          type: 'w'
        }
      })
    },
    onModalClose () {
      this.leaveConfirmed = false // 用户关闭弹窗时重置确认状态
      this.$store.commit('setWaitShow', false)
    },
    proceedToNextRoute () {
      this.leaveConfirmed = true // 用户确认离开
      this.$store.commit('setWaitShow', false)
      this.$router.push('/' + this.leaveToRoute)
    },
    activeEventOfNav (GatewayType) {
      const activeList = this.gatewayList.filter((item) => {
        return this.DepositGatewayActivity.includes(item.Name) && GatewayType === item.GatewayType2
      })
      return activeList && activeList.length > 0
    },
    how2UseUpi () {
      this.showUpiHelpPop = true
    },
    /****
     *
     * @param label
     * 2021-07-31 CHP 点击当前Label时，刷新当前页
     */
    selectTab (key) {
      if (key === this.$route.name) {
        return false
      }
      this.setCurrentRoute(key)
      this.$router.push('/' + key)
      if (this.$route.name === 'Deposit' && this.warningShow === true) {
        this.warningShow = false
        setTimeout(() => {
          this.warningShow = true
        })
      }
    },
    getDepositActivity () { // 2023-04-13 hp 更新周六会员日充值赠送页面效果
      const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
      const url = '/innovation/account/get/deposit/activity'
      const data = {
        userId: userInfo.UserId || ''
      }
      request('post', url, data, true).then(res => {
        this.activity = res
        this.fetchGateWay()
      })
    },
    fetchAmount (value, type, index, indx) {
      switch (type) {
        case 'deposit':
          this.depositAmount = value
          this.computeDepositTotal(value, index, indx)
          break
        case 'withdraw':
          this.withdrawAmount = value
          break
      }
    },
    computeDepositTotal (value, index, indx) {
      if (this.selectedGateway.DepositDiscountRange && this.selectedGateway.DepositDiscountRange[index] && this.selectedGateway.DepositDiscountRange[index][indx]) {
        this.depositCashBonus.amount = value

        if (this.$store.state.userFirstDeposit === true || !this.showPercent) {
          this.depositCashBonus.cash = this.selectedGateway.DepositDiscountRange[index][indx] * 1
        } else {
          this.depositCashBonus.cash = value * this.selectedGateway.DepositDiscountRange[index][indx] * 0.01
        }

        this.cashUpPerc = this.selectedGateway.DepositDiscountRange[index][indx]
        this.depositCashBonus.total = this.depositCashBonus.amount + this.depositCashBonus.cash // 移除bonus by HHY 2022-10-29
      } else {
        this.depositCashBonus.amount = value
        this.depositCashBonus.cash = 0
        this.cashUpPerc = 0
        this.depositCashBonus.total = this.depositCashBonus.amount + this.depositCashBonus.cash
      }
    },
    fetchTransaction (item) {
      this.selectedGateway = item
      this.depositAmount = item.DepositDefultAmount
      this.locateInDepositRangeAndComputeDepositTotal()
    },
    updateDiscountDate () {
      // 建立一个数组放入过期充赠券的Guid
      let expireGuid = []
      this.discounts.forEach((discount, index) => {
        let timeShow = ''
        if (discount.date) {
          timeShow = this.getRemainingTime(discount.date)
          this.discounts[index].name = discount.onlyName + ' ' + discount.rate + '% (' + timeShow + ')'
          if (timeShow === 'expire') {
            expireGuid.push(discount.guid)
          }
        }
        if (this.discountType === 'deposit630_discount' || this.discountType === 'wheel_deposit' || this.discountType === 'inner_discount' || this.discountType === '7day_gift_version_c') {
          this.discountName = this.discounts.filter((e) => {
            return e.guid === this.discountGuid
          })[0].name
        }
      })
      // 刷新掉已经过期的充赠券
      if (expireGuid && expireGuid.length > 0) {
        this.discounts = this.discounts.filter((e) => {
          return !expireGuid.includes(e.guid)
        })
      }
      if (expireGuid.includes(this.discountGuid)) {
        this.chooseDiscountType(this.discounts[0])
      }
    },
    getRemainingTime (date) {
      let date2 = new Date(date)
      let date1 = new Date()
      // 计算时间差（以毫秒为单位）
      let timeDiff = date2.getTime() - date1.getTime()

      // 如果时间差小于一分钟，返回 "0 天 0 小时 0 分钟"
      if (timeDiff < 60000 && timeDiff > 0) {
        return '00d 00:00'
      }
      if (timeDiff <= 0) {
        return 'expire'
      }

      // 将时间差转换为天、小时、分钟
      let days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
      let hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))

      // 构建输出字符串
      let result = `${this.formatTwoDigits(days)}d ${this.formatTwoDigits(hours)}:${this.formatTwoDigits(minutes)}`
      return result
    },
    // 辅助函数：确保输出两位数格式
    formatTwoDigits (num) {
      return num.toString().padStart(2, '0')
    },
    fetchAccount () {
      if (this.userInfo) {
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: this.userInfo.UserId
        }
        request('post', url, data, true).then(res => {
          // this.warningShow = res.WarningSwitch
          // this.WithdrawwarningShow = res.WithdrawableWarningSwitch
          // this.WarningEN = res.WarningEN
          // this.WarningIN = res.WarningIN
          // this.WithdrawableWarningEN = res.WithdrawableWarningEN
          // this.WithdrawableWarningIN = res.WithdrawableWarningIN
          let index = res.InviteLink.indexOf('/Share')
          if (index === -1) {
            index = res.InviteLink.toLowerCase().indexOf('/share')
          }
          if (index !== -1) {
            const pre = res.InviteLink.substring(0, index)
            res.InviteLink = res.InviteLink.replace(pre, 'https://' + location.host)
          }
          this.accountInfo = res
          this.fetchAmount(this.withdrawAmountList[0][1], 'withdraw')
        }).catch(err => {
          console.log(err)
        })
      }
    },
    showWithdrawalRules () {
      if (this.feeFreeStatus === 0) {
        this.popMessage = this.$t('lang.account.withdrawalRuleList')
      } else if (this.feeFreeStatus === 1) {
        this.popMessage = this.$t('lang.account.withdrawalRuleListB')
      } else if (this.feeFreeStatus === 2) {
        this.popMessage = this.$t('lang.account.withdrawalRuleListC')
      } else {
        this.popMessage = this.$t('lang.account.withdrawalRuleListD')
      }
      this.showPopMessage = true
      this.popType = 2
    },
    closeDepositMsgPop () {
      this.showPopMessage = false
      if (this.popType === 0) {
        this.doDeposit()
      }
    },
    closeDepositMsgPop2 () {
      this.showPopMessage2 = false
    },
    handleDeposit () {
      if (!this.agreeCheck) {
        Toast(this.$t('lang.account.check'))
        return
      }
      if (!this.depositAmount) {
        Toast(this.$t('lang.account.selectDepositAmount'))
        return
      }

      if (!this.selectedGateway) {
        Toast(this.$t('lang.account.selectUPIChannel'))
        return
      }

      if (!this.userInfo) {
        Toast(this.$t('lang.account.needLogin'))
        return
      }

      if (this.selectedGateway.RuleText) {
        this.popMessage2 = this.selectedGateway.RuleText
        this.showPopMessage2 = true
        this.popType = 0
      } else {
        if (this.selectedGateway && this.selectedGateway.GatewayMode === 'seamless') {
          this.UpiInfoPopShow = true
        } else {
          this.doDeposit()
        }
        // else {
        //     this.BankTransferInfoPopShow = true
        //   }
        // this.doDeposit()
      }
    },
    doNewOrder () {
      LogUtils.saveUserEvent('DepositMonitoring2', this.userInfo.UserId)
      this.gatewayErrorShow = false
      const url = '/innovation/payments/deposit2'
      request('post', url, this.retryObject).then(res => {
        // 2021-08-13 C007 增加处理Depsoit网关处于维护状态的逻辑
        if (res.Code > 0) {
          // start 2021-07-30 C007 跳转第三方前显示动画
          if (document.getElementById('loading').innerHTML.trim() === '') {
            var imageHtml = '<div><img src="static/images/loading.gif" alt=""></div>'
            document.getElementById('loading').innerHTML = imageHtml
          }
          document.getElementById('loading').style.display = 'block'
          // end 2021-07-30 C007

          if (res.Code === 1 && res.Url) {
            if (res.Operation === 'jump') {
              this.$store.commit('setDepositListening', true)
              location.href = res.Url
            } else if (res.Operation === 'QRCode') {
              this.QRCodeShow = true
              this.QRCode = res.Url
            } else {}
          } else {
            this.formData = res.FormField
            this.GladPayUrl = res.Url
            this.$nextTick(() => {
              this.$refs.form.submit()
            })
          }
        } else {
          switch (res.Code) {
            case -1:
              this.retryObject = res.RequestParams
              this.retryObject.RetryMsg = res.Message
              this.retryObject.IsRetry = true
              this.gatewayErrorShow = true
              LogUtils.saveUserEvent('DepositMonitoring1', this.userInfo.UserId)
              break
            case -2:
              this.showUpgradePop = true
              break
          }
        }
        document.getElementById('loading').style.display = 'none'
      }).catch(err => {
        console.log(err)
        Toast(this.$t('lang.common.errorPrompt'))
      })
    },
    doDeposit () {
      if (this.selectedGateway.Name.toLowerCase() === 'payru') {
        const payru = localStorage.getItem('payru') // 记录弹出状况
        if (!payru) { // 判断是否弹出过没弹出过直接弹出
          const param1 = {
            date: Date.now(),
            count: 1,
            total: 1
          }
          localStorage.setItem('payru', JSON.stringify(param1))
          this.payRuAlertShow = true
        } else {
          const param2 = JSON.parse(payru)
          if (param2.total >= 9) { // 弹出9次永久不弹出了
            this.deposit2()
            return
          }
          if (LogUtils.isSameDay(Date.now(), param2.date)) { // 弹出过且是今天弹出
            if (param2.count < 3) { // 次数小于三次
              const param3 = {
                date: Date.now(),
                count: (1 + param2.count) * 1,
                total: (1 + param2.total) * 1
              }
              localStorage.setItem('payru', JSON.stringify(param3))
              this.payRuAlertShow = true
            } else { // 次数超过3次了不弹出了
              this.deposit2()
            }
          } else { // 今天没弹过直接弹
            const param4 = {
              date: Date.now(),
              count: 1,
              total: (1 + param2.total) * 1
            }
            localStorage.setItem('payru', JSON.stringify(param4))
            this.payRuAlertShow = true
          }
        }
      } else {
        this.deposit2()
      }
    },
    closePayRu () {
      this.payRuAlertShow = false
      this.deposit2()
    },
    closePayFutureMsg () {
      this.payFutureMsgShow = false
    },
    deposit2 () {
      const url = '/innovation/payments/deposit2'
      const data = {
        userId: this.userInfo.UserId,
        amount: this.depositAmount,
        hasBonus: this.bonusCheck,
        apkVersion: localStorage.getItem('apkV') ? localStorage.getItem('apkV') : '1.0.0',
        cid: localStorage.getItem('cid'),
        gateway: this.selectedGateway.Name,
        internation: this.$store.state.internation, // 2021-11-25 CHP 增加
        cashUpPercentage: this.cashUpPerc, // 2022-08-23 HHY 增加 // 2022-11-11 HHY 暂时没用到后台（后台未接收），目前只是前端显示用
        forCopyVisible: false,
        discountType: this.discountType,
        GiftUuid: this.discountGuid,
        IsRetry: false,
        VpaAddress: this.VpaAddress
      }
      request('post', url, data).then(res => {
        // 2021-08-13 C007 增加处理Depsoit网关处于维护状态的逻辑
        if (res.Code > 0) {
          if (res.Url === 'seamless') {
            this.payFutureMsgShow = true
            return
          }
          // start 2021-07-30 C007 跳转第三方前显示动画
          if (document.getElementById('loading').innerHTML.trim() === '') {
            var imageHtml = '<div><img src="static/images/loading.gif" alt=""></div>'
            document.getElementById('loading').innerHTML = imageHtml
          }
          document.getElementById('loading').style.display = 'block'
          // end 2021-07-30 C007

          if (res.Code === 1 && res.Url) {
            // this.$store.commit('setDepositListening', true)
            // location.href = res.Url
            if (res.Operation === 'jump') {
              this.$store.commit('setDepositListening', true)
              location.href = res.Url
            } else if (res.Operation === 'QRCode') {
              this.QRCodeShow = true
              this.QRCode = res.Url
            } else {}
          } else {
            this.formData = res.FormField
            this.GladPayUrl = res.Url
            this.$nextTick(() => {
              this.$refs.form.submit()
            })
          }
        } else {
          switch (res.Code) {
            case -1:
              this.retryObject = res.RequestParams
              this.retryObject.RetryMsg = res.Message
              this.retryObject.IsRetry = true
              this.gatewayErrorShow = true
              LogUtils.saveUserEvent('DepositMonitoring1', this.userInfo.UserId)
              break
            case -2:
              this.showUpgradePop = true
              break
          }
        }
        document.getElementById('loading').style.display = 'none'
      }).catch(err => {
        console.log(err)
        Toast(this.$t('lang.common.errorPrompt'))
      })
    },
    isMondayOrWeekend () {
      // 获取当前星期（0=周日, 1=周一 ... 6=周六）
      const day = new Date().getDay()
      // 判断是否为 周一(1)、周六(6)、周日(0)
      if (day === 1 || day === 6 || day === 0) {
        this.handleWithdraw()
        // this.mondayOrWeekendPopShow = true
      } else {
        this.handleWithdraw()
      }
    },
    handleWithdraw () {
      this.mondayOrWeekendPopShow = false
      if (this.withdrawAmount === 0) return Toast(this.$t('lang.account.selectWithdrawAmount'))
      this.withdrawSetup = 'account'
      this.doWithdraw(true)
      return
      // eslint-disable-next-line no-unreachable
      if (!this.withdrawAmount) {
        return Toast(this.$t('lang.account.chooseWithdrawAmount'))
      }
      if (this.userInfo) {
        if (!this.userInfo.Mobile) {
          request('post', '/innovation/account/getuserinfo', {
            userId: this.userInfo.UserId,
            isEditPage: false
          }).then(res => {
            if (res.Mobile) {
              this.userInfo.Mobile = res.Mobile
              localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
            } else {
              this.showBindMobileAlert = true
            }
          })
          // eslint-disable-next-line no-unreachable
        } else {
          this.doWithdraw()
        }
      }
    },
    openDeatilShow (detailContent) {
      if (this.lang === 'IN') {
        this.detailContent = detailContent.DetailIN
      } else {
        this.detailContent = detailContent.DetailEN
      }
      this.deatilShow = true
    },
    doWithdraw (noShowMessage) {
      //
      if (this.activeBankAccount && this.activeBankAccount.BankCardVerifyStatus > 0) {
        let url = 'innovation/payments/validatewithdrawnsendhint/kyc_verification_free'
        const data = {
          userId: this.userInfo.UserId,
          amount: this.withdrawAmount,
          BankAccountId: this.activeBankAccount.Id
        }
        request('post', url, data).then(res => {
          this.withdrawFee = res.Value
          let inner = 'lang.withdrawMsg.message' + res.Code

          if (res.Code === 7 || res.Code === 8) { // 2022-11-29 HHY 添加确认确认框
            if (res.Code === 8) {
              this.withdrawConfirmText = this.$t(inner).replace('{amount}', this.$t('lang.account.currencyType') + res.Value)
            } else {
              this.withdrawConfirmText = this.$t(inner)
            }
            if (noShowMessage) {
              return
            }
            this.withdrawSetup = ''
            this.withdrawConfirmText = this.$t('lang.WithdrawalSuccessful.confirmWithDrawTip').replace('{account}', this.withdrawAmount)
            this.$store.state.confirmWinShow = true // 弹出confirm窗
          } else {
            let msg = this.$t(inner)
            if (res.Code === 6) {
              msg = msg.replace('{amount}', res.Value)
            }
            Toast(msg)
          }
        }).catch(err => {
          if (err.status === 400) {
            let inner = 'lang.withdrawMsg.message' + err.data.Code
            let msg = this.$t(inner)
            if (err.data.Code === 6) {
              msg = msg.replace('{amount}', err.data.Value)
            }
            Toast(msg)
          }
        })
      } else {
        Toast(this.$t('lang.account.promptToSubmitBankAccount'))
      }
    },
    // 2022-11-29 HHY 点击confirm的确认按钮后执行
    confirmWithDraw () {
      const data = {
        userId: this.userInfo.UserId,
        amount: this.withdrawAmount,
        BankAccountId: this.activeBankAccount.Id
      }
      // const url = '/innovation/payments/withdraw2'
      const url = '/innovation/payments/withdraw2/kyc_verification_free'
      request('post', url, data).then(res => {
        let inner = 'lang.withdrawMsg.message' + res.Code
        let msg = this.$t(inner)
        if (res.Code === 6) {
          msg = msg.replace('{amount}', res.Value)
        }
        Toast(msg)
        this.fetchAccount() // 2021-06-19 CHEN ADD refresh account
        // this.$router.push('/WithdrawalSuccessful')
        this.$router.push({
          path: '/WithdrawalSuccessful',
          query: {
            withdrawAmount: this.withdrawAmount
          }
        })
      }).catch(err => {
        if (err.status === 400) {
          let inner = 'lang.withdrawMsg.message' + err.data.Code
          let msg = this.$t(inner)
          if (err.data.Code === 6) {
            msg = msg.replace('{amount}', err.data.Value)
          }
          Toast(msg)
        }
      })
    },
    closeGatewayError () {
      LogUtils.saveUserEvent('DepositMonitoring3', this.userInfo.UserId)
      this.gatewayErrorShow = false
    },
    copy () {
      this.$refs.link.select()
      document.execCommand('copy')
      Toast(this.$t('lang.account.copySuccess'))
    },
    copyCode () {
      this.$refs.shareCode.select()
      document.execCommand('copy')
      Toast(this.$t('lang.account.copySuccess'))
    },
    checkFeeFreeStatus () {
      const url = '/innovation/payments/withdrawal/strategy'
      const data = {
        CampaignId: localStorage.getItem('cid'),
        userId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        if (res && res === 'versionA') {
          this.feeFreeStatus = 0
        } else if (res && res === 'versionB') {
          this.feeFreeStatus = 1
        } else if (res && res === 'versionC') {
          this.feeFreeStatus = 2
        } else {
          this.feeFreeStatus = 3
        }
      }).catch(err => {
        console.log(err)
      })
    },
    fetchVerifyInfo () {
      const url = '/innovation/account/getuserverifyinfo'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        this.setUserVerifyInfo(res.UserVerifyInfo)
        this.setUserBankList(res.BankAccountList)
        const filterList = res.BankAccountList.filter((e) => {
          return e.IsLastUsed === true
        })
        if (filterList.length > 0) {
          this.activeCardId = filterList[0].Id
        }
        if (this.activeCardId === -1 && this.$store.state.bankList && this.$store.state.bankList.length > 0) {
          this.activeCardId = this.$store.state.bankList[0].Id
        }
        this.checkFeeFreeStatus()
        this.chooseCard(this.activeCardId)
      }).catch(err => {
        console.log(err)
      })
    },
    chooseCard (id) {
      let bankList = this.$store.state.bankList
      bankList.forEach((e, i) => {
        e.Index = i
        if (e.Id === id) {
          e.IsLastUsed = true
          this.activeBankAccount = e
        } else {
          e.IsLastUsed = false
        }
      })
      this.setUserBankList(bankList)
    },
    /***
     * 获取支付网关
     * 2021-07-31 C007 创建
     * */
    fetchGateWay () {
      this.discounts = []
      // 没有高优先级充值的情况下,先处理充赠券
      if (!this.activity.FirstDeposit && !this.activity.TwiceDeposit && !this.activity.CallbackDeposit && this.activity.Discounts) {
        this.activity.Discounts.forEach((discount) => {
          const guid = discount.GiftUuid
          const type = discount.GiftType
          const onlyName = this.$t('lang.account.' + type)
          const date = discount.DueDate + ':00'
          const rate = discount.Discount
          const timeShow = this.getRemainingTime(date)
          const name = onlyName + ' ' + rate + '% (' + timeShow + ')'
          if (timeShow !== 'expire') {
            this.discounts.push({type: type, name: name, onlyName: onlyName, guid: guid, date: date, rate: rate})
          }
        })
      }
      // 首充/二充/回归 使用后台返回的discountType 优先级第一
      if (this.activity.FirstDeposit || this.activity.TwiceDeposit || this.activity.ThirdDeposit || this.activity.CallbackDeposit) {
        this.discountType = this.activity.DepositType
        this.discountName = this.$t('lang.account.' + this.discountType)
        this.discounts.unshift({type: this.discountType, name: this.discountName})
      } else if (this.$route.query.param === 'limitTime' || this.$route.query.guid || this.activity.MembersDayDeposit || this.activity.SundayDeposit) {
        if (this.activity.MembersDayDeposit || this.activity.SundayDeposit) { // 会员日
          this.discountType = this.activity.DepositType
          this.discountName = this.$t('lang.account.' + this.discountType)
          this.discounts.unshift({type: this.discountType, name: this.discountName})
        } else { // 没有会员日的情况下,又从天降福利或者充赠券入口进入用户可以选择使用优惠
          this.discountType = 'normal_deposit'
          this.discountName = this.$t('lang.account.' + this.discountType)
          this.discounts.push({type: this.discountType, name: this.discountName})
        }
        if (this.$route.query.param === 'limitTime') { // 天降福利入口进入
          this.discountType = 'welfare_deposit'
          this.discountName = this.$t('lang.account.' + this.discountType)
        }
        if (this.$route.query.guid) { // 充赠券入口进入
          this.discountGuid = this.$route.query.guid
          this.discountType = 'wheel_deposit'
          this.discountName = this.discounts.filter((e) => {
            return e.guid === this.discountGuid
          })[0].name
        }
      } else { // 平民优惠
        this.discounts.push({type: 'normal_deposit', name: this.$t('lang.account.normal_deposit')})
        if (!this.discounts || this.discounts.length === 0) {
          this.discountType = 'normal_deposit'
          this.discountName = this.$t('lang.account.' + this.discountType)
        } else {
          this.discountType = this.discounts[0].type
          this.discountName = this.discounts[0].name
          this.discountGuid = this.discounts[0].guid
        }
      }
      // 有天降福利资格
      if (this.activity.WelfareDeposit && !this.activity.FirstDeposit && !this.activity.TwiceDeposit && !this.activity.CallbackDeposit) {
        // 先放入天降福利到下拉列表
        this.discounts.unshift({type: 'welfare_deposit', name: this.$t('lang.account.welfare_deposit')})
        // 如果不是会员日优惠并且不是从充赠券入口进入，直接选中天降福利
        if (!this.activity.MembersDayDeposit && !this.activity.SundayDeposit && !this.$route.query.guid) { // 选中天降福利
          this.discountType = 'welfare_deposit'
          this.discountName = this.$t('lang.account.' + this.discountType)
        }
      }
      this.freshNav = true
      this.getGateWay2()
    },
    getWarning () {
      const url = '/innovation/account/warning'
      request('post', url, {}, true).then(res => {
        this.WarningEN = res.WarningEN
        this.WarningIN = res.WarningIN
        this.warningShow = res.WarningSwitch
        this.WithdrawableWarningEN = res.WithdrawableWarningEN
        this.WithdrawableWarningIN = res.WithdrawableWarningIN
        this.WithdrawwarningShow = res.WithdrawableWarningSwitch
      })
    },
    getGateWay2 () {
      const url = '/innovation/payments/getavailabledepositgateway2'
      const data = {
        userId: this.userInfo.UserId,
        internation: this.$store.state.internation,
        deposittype: this.discountType,
        giftuuid: this.discountGuid
      }
      request('post', url, data).then(res => {
        if (res.Code > 0) {
          if (res.DepositGatewayActivity) {
            this.DepositGatewayActivity = res.DepositGatewayActivity.split(',')
          }
          if (res.MinDeposit && res.MinDepositCids) {
            this.minDeposit = res.MinDeposit
            this.minDepositCids = res.MinDepositCids
          }
          this.gatewayList = res.GatewayList
          var counter = 0
          for (var index in this.gatewayList) { // 给每个gateway增加一个序号字段 by HHY 20220611
            counter++
            const gateway = this.gatewayList[index]
            gateway['No'] = counter
          }
          this.gatewayTypes = res.GatewayTypes // by HHY 20220609
          if (this.gatewayTypes.length > 0) {
            if (this.freshNav) {
              this.depositNav = this.gatewayTypes[0].GatewayType
            }
            if (this.isFromPromotionUpiGuide) {
              this.selectDepositTab('UPI')
              this.gatewayList.forEach(item => {
                if (item.Name === 'UPPay') {
                  this.fetchTransaction(item)
                }
              })
            } else if (res.DefaultType) {
              this.depositNav = res.DefaultType
              this.selectDepositTab(this.depositNav)
            } else {
              this.selectDepositTab(this.depositNav)
            }
          }
        } else {
          Toast(res.Message)
        }
      }).catch(err => {
        console.log(err)
        Toast(this.$t('lang.common.errorPrompt'))
      })
    },
    /***
     * 复制数字货币列表
     * 2021-08-29 WANGXJ 创建
     * */
    coinCopyAddress (coinAddress) {
      let copy = function (e) {
        e.preventDefault()
        let text = coinAddress
        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', text)
        } else if (window.clipboardData) {
          window.clipboardData.setData('Text', text)
        }
      }
      window.addEventListener('copy', copy)
      document.execCommand('copy')
      window.removeEventListener('copy', copy)
    },
    /***
     * upi活动方法 start
     * */
    UpiIconClick () {
      LogUtils.saveUserEvent('UpiGuide_ClickIcon', this.userInfo.UserId)
      this.goToUpiTeaching()
    },
    UpiPopGoClick () {
      LogUtils.saveUserEvent('UpiGuide_PopGo', this.userInfo.UserId)
      this.goToUpiTeaching()
    },
    closeBindMobile () {
      this.showBindMobileAlert = false
    },
    gotoEdit () {
      this.$router.push('/' + 'Edit')
    },
    goToUpiTeaching () {
      if (this.UpiActivityShow === true) {
        this.UpiActivityShow = false
      }
      this.TeachingPopShow = true
    },
    closeUpiActivityShow () {
      this.UpiActivityShow = false
      LogUtils.saveUserEvent('UpiGuide_PopClose', this.userInfo.UserId)
    },
    closeUpiGiftReward () {
      if (this.teachingAlertMode === 1) {
        LogUtils.saveUserEvent('UpiGuide_RewardClose', this.userInfo.UserId)
      }
      this.showUpiGiftReward = false
    },
    UpiGiftRewardToDo () {
      this.showUpiGiftReward = false
      switch (this.teachingAlertMode) {
        case 1:
          LogUtils.saveUserEvent('UpiGuide_RewardClaim', this.userInfo.UserId)
          this.selectDepositTab('UPI')
          break
        case 2:
          const url = '/innovation/upi/study/collect_reward'
          const data = {
            userId: this.userInfo.UserId
          }
          request('post', url, data).then(res => {
            if (res > 0) {
              Toast(this.$t('lang.common.success'))
              this.fetchBalance()
              this.getUpiUserData()
            }
          })
          break
      }
    },
    closeTeaching () {
      this.TeachingPopShow = false
    },
    finishUpiStudy () {
      this.TeachingPopShow = false
      if (this.UpiUser.StudyEnd === false) {
        const data = {
          userId: this.userInfo.UserId
        }
        const url = 'innovation/upi/study/study_end'
        request('post', url, data, true).then(res => {
          if (res === true) {
            this.UpiUser.StudyEnd = true
            this.teachingAlertMode = 1
            this.showUpiGiftReward = true
          }
        })
      } else {
        if (this.UpiUser.RedDot === true) {
          this.teachingAlertMode = 2
          this.showUpiGiftReward = true
        } else if (this.UpiUser.RewardEnd === true) {
          this.teachingAlertMode = 3
          this.showUpiGiftReward = true
        } else {
          this.teachingAlertMode = 1
          this.showUpiGiftReward = true
        }
      }
    },
    finishUpiForcePop () {
      const url = '/innovation/upi/study/popup_end'
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data, true)
    },
    getUpiUserData () {
      const url = '/innovation/upi/study/get_data'
      this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : ''
      if (!this.userInfo) {
        return
      }
      const data = {
        userId: this.userInfo.UserId
      }
      request('post', url, data, true).then(res => {
        /*
        ForcePopUp 是否强弹
        PopUpEnd   弹出结束
        RedDot     是否有红点
        Reward     奖励金额
        RewardEnd  领取过奖励
        StudyEnd   学习过
        Target     充值目标金额，才能领奖
        */
        if (res !== 0) {
          this.UpiUser = res
          if (res.ForcePopUp === true) {
            this.UpiActivityShow = true
            this.finishUpiForcePop()
          }
        }
      })
    },
    /***
     * upi活动方法 end
     * */
    closeUpgrade () {
      this.showUpgradePop = false
    },
    closeUpiHelp () {
      this.showUpiHelpPop = false
    },
    selectDepositTab: function (item) { // 选择gatewaytype的tab时触发 by HHY 20220609
      this.depositNav = item
      this.selectGatewaysByType(item)
    },
    processArray (originalArray) {
      // 1. 展平数组并过滤小于 500 的数字
      const flatArray = originalArray
        .flat() // 展平数组
        .filter(num => num >= 500) // 移除小于 500 的数字

      // 2. 重新分组，每组 3 个元素
      const groupSize = 3
      const result = []
      for (let i = 0; i < flatArray.length; i += groupSize) {
        result.push(flatArray.slice(i, i + groupSize))
      }

      return result
    },
    selectGatewaysByType: function (item) {
      this.gatewayListByType = []
      for (var index in this.gatewayList) {
        const gateway = this.gatewayList[index]
        if (gateway.GatewayType2 === item) {
          // if (gateway.Name.toLowerCase() === 'future') { // test渠道测试FuturePay
          //   if (localStorage.getItem('cid') && localStorage.getItem('cid') === 'test') {
          //     this.gatewayListByType.push(gateway)
          //   }
          // } else {
          //   this.gatewayListByType.push(gateway)
          // }
          // 充值过的用户才能用 'futureqr', 'future', 'decent'这仨通道
          if (!(this.discountType === 'first_deposit' && ['futureqr', 'future', 'decent', 'superpay', 'pay666', 'aipay'].includes(gateway.Name.toLowerCase()))) {
            this.gatewayListByType.push(gateway)
          }
        }
      }
      if (this.gatewayListByType.length > 0) {
        if (this.minDeposit && this.minDepositCids && localStorage.getItem('cid') && this.minDepositCids.includes(localStorage.getItem('cid'))) {
          this.gatewayListByType.forEach((gatewayList) => {
            gatewayList.DepositRange = this.processArray(gatewayList.DepositRange)
            gatewayList.DepositDefultAmount = gatewayList.DepositDefultAmount < this.minDeposit ? gatewayList.DepositRange[0][0] : gatewayList.DepositDefultAmount
          })
        }
        if (this.freshNav) {
          this.selectedGateway = this.gatewayListByType[0]
          this.depositAmount = this.selectedGateway.DepositDefultAmount
        } else {
          this.selectedGateway = this.gatewayListByType.filter((gateway) => {
            return this.selectedGateway.Id === gateway.Id
          })[0]
          if (!this.selectedGateway) {
            this.selectedGateway = this.gatewayListByType[0]
          }
          this.freshNav = true
        }
        this.locateInDepositRangeAndComputeDepositTotal()
      }
    },
    showTypeDrop () {
      this.typeDropShow = !this.typeDropShow
    },
    judgeActive (item) {
      if (this.discountType === item.type && this.discountName === item.name && this.discountType !== 'wheel_deposit' && this.discountType !== 'deposit630_discount' && this.discountType !== 'inner_discount' && this.discountType !== '7day_gift_version_c') {
        return true
      } else if (this.discountType === item.type && this.discountName === item.name && this.discountGuid === item.guid && (this.discountType === 'wheel_deposit' || this.discountType === 'deposit630_discount' || this.discountType === 'inner_discount' || this.discountType === '7day_gift_version_c')) {
        return true
      } else {
        return false
      }
    },
    chooseDiscountType (item) {
      if (this.judgeActive(item)) {
        this.typeDropShow = false
        return
      }
      this.discountName = item.name
      this.discountType = item.type
      if (this.discountType === 'deposit630_discount' || this.discountType === 'wheel_deposit' || this.discountType === 'inner_discount' || this.discountType === '7day_gift_version_c') {
        this.discountGuid = item.guid
      }
      this.freshNav = false
      this.getGateWay2()
      this.typeDropShow = false
    },
    closeDepositStep () {
      this.showDepositStep = false
    },
    locateInDepositRangeAndComputeDepositTotal () { // 寻找默认充值额度在所有可选充值额度中得索引位置
      var x = -1
      var y = -1
      for (let i = 0; i < this.selectedGateway.DepositRange.length; i++) {
        var range = this.selectedGateway.DepositRange[i]
        for (let j = 0; j < range.length; j++) {
          if (this.selectedGateway.DepositRange[i][j] === this.depositAmount) {
            x = i
            y = j
          }
        }
      }
      this.computeDepositTotal(this.depositAmount, x, y) // 根据索引位置，计算默认充值额度下，用户能得到的最后值（考虑返利、bonus等） by HHY 2022-08-16
    },
    showTipsContentByDelay () {
      setTimeout(() => {
        this.tipsDelayAwhile = true
        return null
      }, 8000)
    },
    changeDepositRangeBg (index) { // 2022-10-21 HHY 根据行变换充值优惠显示背景
      if (index === 0) {
        return 'discountRange'
      } else if (index === 1) {
        return 'discountRange2'
      } else if (index === 2) {
        return 'discountRange3'
      } else {
        return 'discountRange'
      }
    }
  },
  /****
   *
   * @param to
   * @param from
   * @param next
   * 2021-07-26 C007 Fix error: 用户未登录时，获取VerifyInfo出错
   */
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.query.key === 'UpiGuide' || to.query.key === 'UpiGuide') { // 2022-10-21 HHY 如果来自promotion页的UPI活动
        vm.isFromPromotionUpiGuide = true
        // fetchTransaction
      }
    })
  },
  /****
   * 离开页面时显示动画，在Main.js里进入页面时取消动画
   * 这个主要是为了解决从充值页面切换到支付网关之间的停顿
   * @param to
   * @param from
   * @param next
   */
  beforeRouteLeave (to, from, next) {
    this.isFromPromotionUpiGuide = false // 初始化
    this.isFirstDeposit = false
    if (this.userInfo && this.waitPopShow && !this.leaveConfirmed && from.name === 'Deposit' && to.name !== 'Deposit') {
      this.leaveToRoute = to.name
      this.waitPopShow = false
      LogUtils.saveUserEvent('DepositMonitoring4', this.userInfo.UserId)
      localStorage.setItem('waitShowDate', Date.now())
      this.$refs.waitModal.open()
      next(false) // 阻止路由跳转
    } else {
      next() // 允许路由跳转
    }
  },
  beforeDestroy () {
    if (this.discountTimeInterval) {
      clearInterval(this.discountTimeInterval)
    }
  }
}
</script>

<style lang="less" scoped>
.accountPage {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 56px 0 0 0; // 2022-03-27 CHP Fix tab被topbar遮挡
  overflow: scroll;
  overflow-x: hidden;

  .tabList {
    display: flex;
    text-align: center;
    justify-content: space-between;
    align-items: center;
    padding: 15px 5px 0 5px;

    .tab {
      padding: 0 5px 5px;
      font-size: 16px;
      color: #686868;
      flex: 1;
    }

    .tabSelected {
      color: #F6D9AA;
      line-height: 21px;
      font-weight: 500;
      border-bottom: 2px solid #F6D9AA;
    }
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .waringBox {
    display: flex;
    justify-content: center;

    .warning {
      margin-top: 2.777vw;
      //height: max-content;
      //font-size: 3.888vw;
      font-weight: 400;
      line-height: 4.8vw;
      letter-spacing: -0.01em;
      text-align: left;
      background: rgba(110, 10, 10, 0.41);
      //color: #F5F1F1;
      padding-left: 5vw;
      animation: blink .6s linear 2;
      height: 10.55vw;
      width: 92.94vw;
      color: #D32F13;
      font-size: 2.77vw;
      border-radius: 1.666vw;
      overflow: hidden;
      overflow-y: auto;
    }
  }

  .tabContainer {
    flex: 1;
    margin-top: 15px;
    overflow: visible;
    padding: 0 16px 120px;

    .caption {
      font-size: 18px;
      line-height: 21px;
      color: #F6D9AA;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }

    .bonus-wagering {
      font-size: 14px;
      color: #FFFFFF;
      text-decoration: underline;
    }

    .tips {
      font-size: 12px;
      line-height: 14px;
      color: #686868;
      margin-bottom: 10px;
      margin-top: -10px;
    }

    .warnings {
      color: #F6D9AA;
      margin-bottom: 25px;
      text-decoration: underline;
    }

    .row {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .inputRow, .btnRow {
        div {
          line-height: 40px;
          border: 1px solid rgba(246, 217, 170, 0.5);
          border-radius: 6px;
        }
      }

      .inputRow {
        display: flex;

        &:not(:last-child) {
          /*margin-bottom: 16px;*/
          margin-bottom: 8px;
        }

        div {
          flex: 1;
          font-size: 16px;
          color: #fff;
          text-align: right;
          padding-right: 15px;
          position: relative;

          &:not(:first-child) {
            margin-left: 9px;
          }

          input {
            font-size: 16px;
            color: #fff;
            text-align: right;
          }

          .coin-name {
            display: inline-block;
            border: none;
          }

          .coin-copy {
            display: inline-block;
          }

          .coin-address {
            border: none;
          }
        }

        .selected {
          font-size: 20px;
          font-weight: 600;
          color: #000000 !important;
          background-color: #F6D9AA;

          > div {
            font-size: 20px;
            font-weight: 600;
            color: #000;
          }
        }

        .claim {
          text-align: center;
          color: #000000;
          background-color: #F6D9AA;
          font-size: 18px;
          padding: 0;
        }
      }

      .secondaryRow {
        display: flex;
        justify-content: right;
        align-items: center;
        gap: 20px;
        line-height: 28px;
        padding-right: 15px;

        .title {
          font-weight: 400;
          font-size: 14px;
          color: #606466;
        }

        .amount {
          font-weight: 700;
          font-size: 22px;
          color: #D0D6D9;
        }
      }

      .btnRow {
        display: flex;

        div {
          flex: 1;
          text-align: center;
          font-size: 20px;
        }

        .depositBtn {
          background-color: #F6D9AA;
          color: #000;
          margin-right: 9px;
        }

        .withdrawBtn {
          color: #F6D9AA;
        }
      }

      .linkRow {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;

        label {
          width: 100%;
          line-height: 30px;
          display: flex;
          justify-content: flex-start;

          input {
            font-size: 14px;
            color: #C4C4C4;
            width: 100%;
          }
        }

        .copy {
          font-size: 14px;
          color: rgba(246, 217, 170, 0.5);
          padding: 5px 0;
          border: 1px solid #818181;
          line-height: 20px;
          white-space: nowrap;
          display: flex;
          justify-content: center;
          width: 15vh;
        }
      }

      .safe-wallet-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 40px;
        font-size: 20px;

        .input {
          border: 1px solid rgba(246, 217, 170, 0.5);
          border-radius: 6px;
          color: #fff;
          text-align: right;
          padding-right: 15px;
          width: calc(100vw - 130px - 32px - 10px);
        }

        .btn {
          width: 130px;
          background-color: #F6D9AA;
          text-align: center;
          border-radius: 6px;
          color: #000000;
          display: flex;

          .btn-inner {
            margin: 0 auto;
            display: flex;

            .icon {
              width: 22px;
              height: 22px;
              margin: 9px 10px 9px 0px;
            }
          }
        }
      }
    }

    .deposit {
      .activeEvent {
        position: absolute;
        top: -2.5vw;
        right: -2.25vw;
        font-size: 3.055vw;
        font-weight: 400;
        text-align: center;
        color: #FFFFFF;
        height: 4.166vw;
        line-height: 4.166vw;
        width: max-content;
        padding: 0 2vw;
        background: #FE1E28;
        border-radius: 3.888vw 3.888vw 3.888vw 0;
        z-index: 1;
      }

      .cashCount {
        font-size: 40px;
        line-height: 47px;
        color: #fff;
        text-align: center;
        /*margin-bottom: 30px;*/
        margin-bottom: 10px;
      }

      .caption {
        justify-content: center;
        /*margin-bottom: 20px;*/
      }

      .row {
        .inputRow {
          div {
            padding: 0;
            text-align: right;
            position: relative;
            overflow: hidden;
            font-size: 13px;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;

            .discountRange {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 13px;
              font-size: 11px;
              width: 40px;
              min-width: 40px;
              margin-left: 4px;
              background-color: #ff525a;
              border-radius: 12px 12px 12px 0;
              border: none;
            }

            .discountRange2 {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 13px;
              font-size: 11px;
              width: 40px;
              min-width: 40px;
              margin-left: 4px;
              background-color: #ff5b39;
              border-radius: 12px 12px 12px 0;
              border: none;
            }

            .discountRange3 {
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 12px;
              font-size: 11px;
              width: 40px;
              min-width: 40px;
              margin-left: 4px;
              background-color: #fe1e28;
              border-radius: 12px 12px 12px 0;
              border: none;
            }
          }
        }

        .gatewayRow {
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;

          .gatewayItem {
            /*flex:1*/
            margin-top: 2px;
            height: 11vw;

            .gatewayRadio {
              position: relative;
              display: flex;
              align-items: center;
              white-space: nowrap;
              height: 100%;

              .gatewayHot {
                background-color: red;
                width: 24px;
                height: 24px;
                border-radius: 12px;
                position: absolute;
                top: -21px;
                right: 45px;
                font-size: 11px;
                color: #ffffff;
                padding: 4px 0 0 0;
                text-align: center;
              }

              .inlineDiv {
                position: relative;
                height: 92%;
                width: 80%;
                margin-top: 3%;
                margin-bottom: 3%;
                margin-left: 2%;
                border-radius: 8px;
                border: 1px solid #F6D9AA;

                .gatewayDiscount {
                  position: absolute;
                  width: 60px;
                  height: 18px;
                  border-radius: 15px;
                  margin-left: 3px;
                  color: #FE1E28;
                  font-size: 11px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  top: -1px;
                  right: -6px;
                }

                .gatewayTxt {
                  display: flex;
                  margin-left: 7px;
                  align-items: center;
                  height: 100%;
                  font-size: 16px;
                  color: #fff;
                }

                .fire {
                  position: absolute;
                  right: 3vw;
                  width: max-content;
                  height: 9.5vw;
                  display: flex;
                  align-items: center;

                  img {
                    height: 4.166vw;
                  }
                }
              }
            }
          }

          .upiLogo {
            /*height: 25px;*/
            margin-left: 5px;
          }
        }

        .checkRow {
          margin-top: 20px;
          /*margin-bottom: 50px;*/
          font-size: 12px;
          line-height: 14px;
          color: #fff;

          label {
            height: 14px;
            margin-right: 15px;
          }

          div {
            display: flex;
            align-items: center;

            &:first-child {
              margin-bottom: 15px;
            }

            span {
              color: #F6D9AA;
            }
          }
        }

        .cash-box {
          background: rgba(246, 217, 170, 0.1);
          border-radius: 6px;
          line-height: 25px;
          padding: 10px 10px;
          text-align: center;

          .caption {
            color: #F6D9AA;
          }

          .cash {
            color: #FFFFFF;
          }
        }

        .transfer-box {
          text-align: center;
          position: relative;
          width: 70px;

          .transfer-inner {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .img {
              width: 22px;
              height: 22px;
            }

            .text {
              color: #F6D9AA;
            }
          }
        }

        .nav {
          display: flex;
          margin: 5px 0px 10px 0px;
          border-radius: 6px;
          border: 1px solid rgba(246, 217, 170, 0.5);
          position: relative;

          .new {
            position: absolute;
            top: -2.6vw;
            right: -2.2vw;
            width: max-content;
            height: 5.556vw;
            z-index: 2;

            img {
              width: 100%;
            }
          }

          .nav-item {
            flex: 1;
            line-height: 30px;
            text-align: center;
            position: relative;

            .secureHint {
              position: absolute;
              top: -17px;
              width: 100%;
              height: 20px;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              font-size: 12px;
              padding-bottom: 5px;
              border-top-left-radius: 6px;
              border-top-right-radius: 6px;
              transform: translate(12px, 0);
            }

            .secureHintMask {
              position: absolute;
              background-color: #161616;
              top: 0;
              width: 100%;
              height: 8px;
              border-top-left-radius: 6px;
              border-top-right-radius: 6px;
            }

            .secureHintMaskSelected {
              background-color: #F6D9AA;
            }
          }

          .superSecureHint {
            position: absolute;
            width: 66.67%;
            right: 0;
            top: -17px;
            height: 17px;
            background-image: linear-gradient(45deg, #ff6a01, red);
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
          }

          .active {
            position: relative;
            background: #F6D9AA;
            color: #543200;
            border-radius: 6px;
            z-index: 0;
          }
        }
      }

      .gateways-by-type {
        flex: 1;
        display: none;

        .how2UseUpi {
          margin-top: 2vw;
          font-size: 3.05vw;
          line-height: 3.333vw;;
          height: 4vw;
          font-weight: 400;
          text-align: left;
          color: #767676;
          display: flex;
          align-items: flex-end;
          justify-content: flex-start;

          img {
            height: 3.333vw;
            margin-right: 1.5vw;
            margin-bottom: 0.2vw;
          }
        }

        .howtoDeposit {
          width: 160px;
          background-color: #000;
          color: #686868;
          font-size: 13px;
          top: 28px;
          padding: 2px;
          white-space: nowrap;

          a {
            color: red;
            font-weight: bold;
          }
        }
      }

      .gateways-by-type-active {
        display: block
      }

      .carlousel {
        margin-top: 12px;
      }

      .depositWord {
        position: relative;
        font-size: 18px;
        color: #F6D9AA;
        padding: 3.33vw 0 2.222vw 1.388vw;

        .upiTeachingIcon {
          position: absolute;
          top: 2.8vw;
          right: -3.3vw;
          transform: translateY(-50%);

          .img {
            position: relative;
            width: 20vw;
            height: 16.5vw;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            overflow: hidden;

            .redPoint {
              position: absolute;
              right: 4.7vw;
              top: 2.2vw;
              width: 2vw;
              height: 2vw;
              border-radius: 50%;
              background: radial-gradient(74.31% 74.31% at 31.38% 30.73%, #F9273A 0%, #982F39 100%);
            }

            img {
              width: 23.11vw;
              height: 23.26vw;
            }
          }
        }
      }

      .compute-deposit-discount {
        width: 100%;
        height: 60px;
        background-color: #000;
        border-radius: 10px;
        border: solid 1px #F6D9AA;
        margin-top: 10px;
        display: flex;
        overflow: hidden;
        padding: 5px;

        .depositTotalTable {
          width: 100%;
          font-size: 14px;
          color: #F6D9AA;
          border-radius: 2px;
          font-weight: bold;
        }

        .depositTotalTable td {
          background-color: #161616;
          text-align: center;
          padding: 2px 5px;
        }
      }

      .discountTypeChoose {
        margin: 3vw auto 4vw auto;
        width: 98%;
        height: 10vw;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .bonus {
          font-family: Inter;
          font-size: 4.444vw;
          font-weight: 400;
          text-align: left;
          color: #F6D9AA;
        }

        .choose {
          position: relative;
          width: 69.715vw;
          height: 100%;
          background: #000000;
          border: 0.277vw solid #F6D9AA;
          border-radius: 1.111vw;
          display: flex;
          justify-content: space-between;
          padding: 0 5vw;
          z-index: 3;

          .mask {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            opacity: 0;
          }

          .typeDropList {
            position: absolute;
            left: 0;
            top: 10.277vw;
            width: 100%;
            max-height: 50vw;
            overflow-x: hidden;
            overflow-y: auto;
            background: #070707;
            z-index: 1;

            .item {
              font-family: Inter;
              font-size: 3.116vw;
              font-weight: 500;
              text-align: left;
              color: #FFFFFF;
              height: 8.333vw;
              line-height: 8.333vw;
              padding: 0 5vw;
              background: none;
            }

            .active {
              background: #4B4B4B;
            }
          }

          .discountName {
            height: 10vw;
            line-height: 9.5vw;
            font-family: Inter;
            font-size: 3.116vw;
            font-weight: 500;
            text-align: left;
            color: #FFFFFF;
          }

          .chooseDrop {
            height: 100%;
            display: flex;
            align-items: center;

            img {
              height: 2.851vw;
            }
          }
        }
      }

      .deposit-step {
        position: absolute;
        height: 100vh;
        width: 100vw;
        top: 0;
        left: 0;
        z-index: 8;
        background-color: rgba(0, 0, 0, 1);

        .cancel-btn {
          position: fixed;
          top: 20px;
          right: 20px;
          width: 38px;
          height: 38px;
          z-index: 8;
        }

        .deposit-step-img {
          width: 100%;
          overflow-y: scroll;

          img {
            width: 100%;
          }
        }
      }
    }

    .withdraw {
      position: relative;

      .balanceBox {
        width: 93.33vw;
        height: 26.94vw;
        border: 1px solid #F6D9AA;
        border-radius: 2.22vw;
        padding: 2vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;

        .historyPropBtn {
          position: absolute;
          right: 3vw;
          top: 3vw;
          color: #C8C8C8;
          border-bottom: 1px solid;
          padding-bottom: 0.2vw;
        }

        .balance-caption {
          //border: 1px solid red;
          color: #FFFFFF;
          font-size: 4.72vw;
          font-weight: 700;
        }

        .cashCount {
          //border: 1px solid red;
          color: #DEBC86;
          font-size: 6.388vw;
          font-weight: 700;
        }

        .gift-prompt {
          //border: 1px solid red;
        }
      }

      .tips {
        font-size: 12px;
        line-height: 14px;
        color: #686868;
        margin-bottom: 10px;
        margin-top: -10px;
      }

      .warning {
        color: #F6D9AA;
        margin-bottom: 25px;
        text-decoration: underline;
      }

      .row {
        margin-bottom: 20px;

        .operateRow {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .label {
            font-size: 18px;
            line-height: 21px;
            color: #F6D9AA;
            width: calc(100vw - 100px - 30px - 40px);
          }

          .btn {
            width: 100px;
            font-size: 16px;
            line-height: 30px;
            color: rgba(246, 217, 170, 0.5);
            text-align: center;
            border: 1px solid rgba(246, 217, 170, 0.5);
            border-radius: 6px;
          }

          .tips-warn {
            position: absolute;
            right: 0;
            top: 35px;
            height: 42px;
            font-size: 12px;
            line-height: 14px;
            text-align: center;
            color: #ff0000;
            width: 200px;
            word-wrap: break-word;
            overflow-wrap: break-word;
            overflow-y: auto;
          }

          img {
            width: 25px;
            height: 25px;
          }
        }

        .inputRow {
          div:not(.input) {
            padding: 0;
            text-align: center;
          }

          input {
            width: 100%;
          }
        }

        .cash-box {
          background: rgba(246, 217, 170, 0.1);
          border-radius: 6px;
          line-height: 25px;
          padding: 10px 10px;
          text-align: center;

          .caption {
            color: #F6D9AA;
          }

          .cash {
            color: #FFFFFF;
          }
        }

        .transfer-box {
          text-align: center;
          position: relative;
          width: 70px;

          .transfer-inner {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .img {
              width: 22px;
              height: 22px;
            }

            .text {
              color: #F6D9AA;
            }
          }
        }
      }

      .audit-message {
        color: #AA0000;
        font-size: 12px;
        line-height: 14px;
      }
    }

    .submit {
      font-size: 22px;
      line-height: 50px;
      color: #000D2E;
      text-align: center;
      background-color: #F6D9AA;
      border-radius: 6px;
    }
  }

  .maskBg {
    position: fixed;
    background-color: rgba(0, 0, 0, .6);
    height: 100vh;
    width: 100vw;
    z-index: 999;
  }

  .pop-message-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, .9);
    z-index: 10;
    padding: 40px 20px;
    box-sizing: border-box;
    overflow: auto;

    .pop-message-content {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      line-height: 25px;
      padding: 0 20px;
      font-size: 18px;
      color: #F6D9AA;
      /*word-break: break-all;*/
      text-align: left;

      .close-pop-message {
        margin-top: 20px;
        text-align: center;

        .close-pop-btn {
          display: inline-block;
          padding: 2px 20px;
          border: 1px solid #F2F2F2;
          width: 100px;
        }
      }
    }
  }

  .pop-message-wrapper2 {
    position: absolute;
    top: 45%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 86.666vw;
    height: 58.333vw;
    background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%);
    //background-color: rgba(0,0,0,.6);
    border: 0.3vw solid #737373;
    border-radius: 4.166vw;
    z-index: 99999;

    p {
      color: #C4C4C4;
      //border: 1px solid red;
      font-size: 4.722vw;
      text-align: center;
    }

    .pop-message-content {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      line-height: 25px;
      padding: 0 3vw;
      font-size: 18px;
      color: #F6D9AA;
      /*word-break: break-all;*/
      text-align: left;

      .close-pop-message {
        margin-top: 20px;
        text-align: center;
        display: flex;
        justify-content: center;

        .close-pop-btn {
          display: block;
          border-radius: 2vw;
          //border: 1px solid #F2F2F2;
          width: 73.05vw;
          height: 9.44vw;
          background-image: linear-gradient(to right, #EFD6AD, #DAB67C);
          color: #000;
          text-align: center;
          line-height: 9.44vw;
        }
      }
    }
  }

  .payFutureMsg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.60);
    z-index: 999;

    .msgCard {
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 86.667vw;
      height: 69.444vw;
      border: 0.33vw solid #737373;
      border-radius: 4.1667vw;
      background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
      text-align: center;
      padding: 10vw 0 0 0;

      .msg {
        margin: 0 auto 11.5vw auto;
        width: 70.55vw;
        font-family: Inter;
        font-weight: 500;
        font-size: 4.444vw;
        line-height: 6vw;
        color: #8d8d8d;
      }

      .button {
        margin: 5vw auto;
        width: 73.194vw;
        height: 9.444vw;
        line-height: 9.444vw;
        border-radius: 1.3888vw;
        background: linear-gradient(0deg, #F1DAB0, #F1DAB0),
        linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
        font-family: Inter;
        font-weight: 600;
        font-size: 4.166vw;
        text-align: center;
        text-transform: capitalize;
        color: #000000;
      }
    }
  }
  .noWithdrawalsOnWeekendsMarsk{
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .noWithdrawalsOnWeekendsPop{
    display: flex;
    flex-direction: column;
    align-items: center;
    //justify-content: space-around;
    justify-content: center;
    gap: 5vw;
    width: 86.66vw;
    height: 76.66vw;
    background-color: rgb(26,28,27);
    border: 1px solid rgba(115,115,115);
    border-radius: 4.166vw;
    .noWithdrawalsOnWeekendsPopTitle{
      color: #FFFFFF;
      font-size: 5.694vw;
      font-weight: 700;
      width: 69.44vw;
      text-align: center;
    }
    .ConfirmWithdrawal{
      width: 73.197vw;
      height: 9.444vw;
      border-radius: 1.388vw;
      color: #000000;
      font-size: 4.166vw;
      text-align: center;
      line-height: 9.444vw;
      background-image: linear-gradient(to right, #EFD6AD 0%, #DAB67C 100%);
      margin-top: 7vw;
      font-weight: 700;
    }
    .Cancel{
      width: 73.197vw;
      height: 9.444vw;
      border-radius: 1.388vw;
      color: #E1C18D;
      font-size: 4.166vw;
      border: 1px solid #E1C18D;
      text-align: center;
      line-height: 9.444vw;
      background-color: rgb(28,29,28);
      font-weight: 700;
    }
  }
}

.slots {
  .title {
    text-align: center;
    text-transform: capitalize;
    color: #FFFFFF;
    font-size: 5.833vw;
    font-weight: 700;
    letter-spacing: 0.03em;
  }

  .reward {
    color: #DEBC86;
    text-align: center;
    font-size: 10.555vw;
    font-weight: 700;
    margin: 4vw auto 5.5vw auto;
  }

  .sentence {
    width: 71.388vw;
    font-size: 4.722vw;
    font-weight: 400;
    text-align: left;
    color: #C4C4C4;
    margin: 4vw auto 22.3vw auto;
  }

  .desc {
    margin: 2.5vw auto;
    width: 71.722vw;
    font-size: 4.166vw;
    font-weight: 400;
    text-align: left;
    color: #939393;
  }
}

.showMore {
  text-align: center;

  img {
    width: 10px;
  }
}

.withdrawSetupBoxMarsk {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 999;

  .close {
    position: fixed;
    height: 4.05vw;
    width: 4.05vw;
    top: 60vw;
    left: 89vw;
  }

  .close2 {
    position: fixed;
    height: 4.05vw;
    width: 4.05vw;
    top: 72vw;
    left: 89vw;
  }

  .withdrawSetupBox {
    position: fixed;
    left: 3vw;
    bottom: 10vw;
    height: 126.26vw;
    width: 93.33vw;
    //overflow: hidden;
    //border: 1px solid red;
    border-radius: 2.77vw;
    background-color: #242424;
    animation: showIn 0.3s ease-in-out forwards;
  }
}

.withdrawBanner {
  width: 91.111vw;
  height: 31.111vw;
  border-radius: 1.944vw;
  background-color: #2C2929;
  margin-top: 5vw;

  img {
    height: 100%;
    width: 100%;
  }
}

.deatilMask {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  top: 0;
  left: 0;
}
.QRCodeMask{
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.59);
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  top: 0;
  left: 0;

  .QRCodeBox{
    width: 86.666vw;
    height: 103.611vw;
    border: 1px solid rgb(115,115,115);
    border-radius: 4.166vw;
    background-color: rgb(29,29,29);
    position: relative;
    top: -8vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5.833vw;
    animation: openBox 0.2s ease-in-out;
    .title{
      color: #FFFFFF;
      font-size: 5.833vw;
      font-weight: 700;
    }
    .tipBox{
      width: 76.28vw;
      height: 12.222vw;
      border-radius: 1.666vw;
      background-color: #090909;
      color: #888888;
      font-size: 3.6111vw;
      display: flex;
      align-items: center;
      padding-left: 5.622vw;
    }
    .QRCodeImgBox{
      height: 49.44vw;
      width: 49.44vw;
      border: 1px solid;
      .QRCode{
        height: 100%;
        width: 100%;
      }
    }
    .PaymentOnceOnly{
      color: #FF2121;
      font-size: 4.444vw;
      font-weight: 600;
    }
    .close{
      height: 4.333vw;
      width: 4.333vw;
      position: absolute;
      bottom: -7vw;
      left: 40vw;
    }
  }
}

@keyframes openBox {
  0% {
    transform: scale(0);
    opacity: 0; /* 开始时完全透明 */
  }
  50% {
    transform: scale(1.1); /* 在中间稍微放大一点，增加视觉冲击 */
    opacity: 1; /* 在中间变为完全不透明 */
  }
  100% {
    transform: scale(1); /* 结束时恢复到正常大小 */
    opacity: 1; /* 保持完全不透明 */
  }
}

.deatilBox {
  width: 86.66vw;
  height: 116.38vw;
  background-color: rgb(32, 32, 32);
  border: 1px solid #737373;
  border-radius: 4.16vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  @keyframes openBox {
    0% {
      transform: scale(0);
      opacity: 0; /* 开始时完全透明 */
    }
    50% {
      transform: scale(1.1); /* 在中间稍微放大一点，增加视觉冲击 */
      opacity: 1; /* 在中间变为完全不透明 */
    }
    100% {
      transform: scale(1); /* 结束时恢复到正常大小 */
      opacity: 1; /* 保持完全不透明 */
    }
  }

  .title {
    font-size: 5.833vw;
    color: #fff;
    margin-top: 4.8vw;
    display: flex;
    justify-content: center;
    height: 10vw;
  }

  .contentBox {
    padding: 2vw;
    overflow-x: hidden;
    overflow-y: auto;
    white-space: pre-wrap;
    padding: 0vw 7vw;
    //border: 1px solid red;
    height: 85.44vw;
    width: 100%;
  }

  .cancel {
    color: #000D2E;
    font-size: 5vw;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.388vw;
    height: 9.44vw;
    width: 73.197vw;
    background: linear-gradient(to right, #EFD6AD, #DAB67C);
    margin-top: 2vw;

  }
}

@keyframes showIn {
  0% {
    position: fixed;
    bottom: -135vw;
  }
  100% {
    position: fixed;
    bottom: 10vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Account/index.vue